export default "__VITE_ASSET__Bh7DltzW__"